module.exports = __webpack_public_path__ + "static/img/2.447dabf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carrusel/2.png
// module id = qGNW
// module chunks = 5